<rask-pillbox>
    {{vacsStatusText}}
</rask-pillbox>